import { render, staticRenderFns } from "./DraggableGoalItem.vue?vue&type=template&id=d43d1c28"
import script from "./DraggableGoalItem.ts?vue&type=script&lang=ts&external"
export * from "./DraggableGoalItem.ts?vue&type=script&lang=ts&external"
import style0 from "./DraggableGoalItem.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports